import { PartnerInfo } from '../types/registrationTypes';

class OnBehalfOfService {
  private static instance: OnBehalfOfService;

  private _partner: PartnerInfo | null = null;

  private constructor() {}

  static getInstance(): OnBehalfOfService {
    if (!OnBehalfOfService.instance) {
      OnBehalfOfService.instance = new OnBehalfOfService();
    }
    return OnBehalfOfService.instance;
  }

  static get partner(): PartnerInfo | null {
    return OnBehalfOfService.getInstance()._partner;
  }

  static set partner(partner: PartnerInfo | null) {
    OnBehalfOfService.getInstance()._partner = partner;
  }

  static reset(): void {
    OnBehalfOfService.getInstance()._partner = null;
  }
}

export { OnBehalfOfService };

